import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LockIcon, MoonIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './ui/CtaButton';
import { heroBullets, PACK_IMAGE, BRAND, CHECKOUT_URL } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <header className="border-b border-line bg-canvasAlt" data-id="element-129" data-mp="4n9wadwh9812">
      <div className="mx-auto flex max-w-page flex-col items-center px-4 sm:px-6 lg:px-8 pt-5 pb-10 text-center" data-id="element-130" data-mp="12a0it4iflorg">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.25,
        ease: EASE
      }} className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-[0.28em] text-accent" data-id="element-131" data-mp="xbfmvha7pr8t">
          <MoonIcon size={14} className="text-blush" data-id="element-132" data-mp="3d1a4l90jrr80" />
          {BRAND}
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.04
      }} className="mt-2 max-w-4xl font-display text-[1.7rem] leading-[1.15] sm:text-4xl lg:text-[2.75rem] font-bold uppercase text-ink" data-id="element-133" data-mp="382p5xe0y1flo">
          Estás para todos…{' '}
          <span className="text-accent" data-id="element-134" data-mp="399tdr28qeocc">¿pero quién está para vos?</span>
        </motion.h1>

        <motion.img initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.1
      }} src={PACK_IMAGE} alt="Mega Pack Vuelve a Ti: caja del sistema con tarjetas de mindfulness, sanación, sueño, hábitos y relaciones" className="mt-2 w-full max-w-[20rem] object-contain sm:max-w-[24rem] lg:max-h-[40vh] lg:w-auto lg:max-w-none" data-id="element-135" data-mp="3e84m18jdoqsg" />

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.14
      }} className="mt-2 flex w-full max-w-xl flex-col items-center" data-id="element-136" data-mp="2hjf8tvip4mct">
          <p className="max-w-2xl font-display text-base md:text-xl font-bold leading-snug text-ink" data-id="element-137" data-mp="s3mb9x0ezovq">
            Es hora de dejar de ponerte última y volver a darte el lugar que
            también merecés.
          </p>
          <p className="mt-2 text-sm font-semibold uppercase tracking-[0.14em] text-blush" data-id="element-138" data-mp="i9vr34bbm0lu">
            14 días para volver a elegirte y reconectar contigo
          </p>
          <CtaButton href={CHECKOUT_URL} external size="lg" className="mt-3 max-w-md shadow-sm" data-id="element-139" data-mp="1b0drfxkntnvk">
            Quiero empezar hoy
          </CtaButton>
          <div className="mt-3 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-ink-muted" data-id="element-140" data-mp="110wo3msvrm2r">
            <span className="flex items-center gap-1.5" data-id="element-141" data-mp="x37ewkqj4les">
              <ShieldCheckIcon size={14} className="text-success" data-id="element-142" data-mp="3lu026z6yb0yo" />
              Garantía 7 días
            </span>
            <span className="flex items-center gap-1.5" data-id="element-143" data-mp="3hpsf16g55t2k">
              <LockIcon size={14} className="text-ink-subtle" data-id="element-144" data-mp="1x9umefegzlpj" />
              Pago seguro
            </span>
            <span className="flex items-center gap-1.5" data-id="element-145" data-mp="21a4sds29ic4e">
              <ZapIcon size={14} className="text-gold" data-id="element-146" data-mp="218jx2084ip5h" />
              Acceso digital inmediato
            </span>
          </div>
        </motion.div>

        <p className="mt-8 max-w-3xl text-base md:text-lg leading-relaxed text-ink-muted" data-id="element-147" data-mp="2b1ram8d0pbgn">
          Una experiencia práctica que reúne en un solo lugar herramientas para{' '}
          <span className="font-semibold text-ink" data-id="element-148" data-mp="2kydv2w1fm0i5">escucharte nuevamente</span>,
          recuperar espacios propios y crear una rutina de reconexión personal.
        </p>

        <ul className="mx-auto mt-4 flex max-w-4xl flex-wrap justify-center gap-2" data-id="element-149" data-mp="2oyo0a6hegmvy">
          {heroBullets.map(bullet => <li key={bullet} className="flex items-center gap-2 rounded-full border border-line bg-surface px-4 py-2 text-sm text-ink" data-id="element-150" data-mp="umzgnr083w58">
              <CheckIcon size={14} className="flex-shrink-0 text-blush" strokeWidth={3} data-id="element-151" data-mp="4bdxli20sdpo" />
              <span data-id="element-152" data-mp="3vgvvsob6z945">{bullet}</span>
            </li>)}
        </ul>
      </div>
    </header>;
}